import { createContext } from 'use-context-selector'
import { InviteSellerContextProps } from './types'
export const InviteSellerContext = createContext({} as InviteSellerContextProps)
